import React from 'react';
import BrandTalentCrmTable from 'components/common/BrandTalentCrmTable/BrandTalentCrmTable';

const BrandTalentCrm = (): JSX.Element => {
  return <BrandTalentCrmTable />;
};

export default BrandTalentCrm;
